
import { defineComponent } from "vue";
import { Waypoint } from "vue-waypoint";
import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import EnEView from "@/views/EnEView.vue";
import SkillView from "@/views/SkillView.vue";
import WorkView from "@/views/WorkView.vue";
import SpecialView from "@/views/SpecialExperience.vue";

export default defineComponent({
  components: {
    HomeView,
    AboutView,
    Waypoint,
    EnEView,
    SkillView,
    WorkView,
    SpecialView: SpecialView,
  },
  data() {
    return {
      isTop: true,
      navLists: [
        {
          name: "About ",
          path: "#about",
        },
        {
          name: "Experience & Education ",
          path: "#experienceAndEdu",
        },
        {
          name: "Skill ",
          path: "#skill",
        },
        {
          name: "Works ",
          path: "#works",
        },
        {
          name: "Special Experience ",
          path: "#specialExperience",
        },
        {
          name: "Download My Resume ",
          path: "https://www.cakeresume.com/pdf/s--sLpAuKkJ0oryeDeCKNcxNA--/ZkVDB.pdf",
        },
      ],
    };
  },
  methods: {
    onchange(state: any) {
      console.log(state.going);
      if (state.going == "IN") {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    setLang() {
      let currentLang = localStorage.getItem("set-lang");
      localStorage.setItem("set-lang", currentLang == "tw" ? "en" : "tw");
      location.reload();
    },
  },
});
